import { PLAN_PRODUCT_COL_WIDTH } from "@/lib/gridLayout";

interface MonthValue {
  period_date: string;
  quantity: number;
}

export interface ContextData {
  actual_sales: { months: MonthValue[] } | null;
}

interface Props {
  months: string[];
  data: ContextData | null;
  loading: boolean;
}

function fmt(n: number): string {
  if (!n) return "—";
  return n.toLocaleString("en-US");
}

function lookup(series: MonthValue[] | undefined, iso: string): number {
  if (!series) return 0;
  return series.find((m) => m.period_date === iso)?.quantity ?? 0;
}

export default function ProductContextRow({ months, data, loading }: Props) {
  const actual = data?.actual_sales?.months;

  return (
    <tr style={{ borderColor: "var(--border)", background: "var(--muted)" }} className="border-b">
      <td
        style={{ background: "var(--muted)", borderColor: "var(--border)", color: "var(--muted-foreground)", width: PLAN_PRODUCT_COL_WIDTH, maxWidth: PLAN_PRODUCT_COL_WIDTH }}
        className="sticky left-0 z-10 px-3 py-1 border-r text-[10px] uppercase tracking-wider whitespace-nowrap"
      >
        Past Period Actual Sales
      </td>
      {months.map((m) => (
        <td
          key={m}
          style={{ color: "var(--muted-foreground)" }}
          className="px-1.5 py-1 text-right text-[11px] tabular-nums"
        >
          {loading ? "—" : fmt(lookup(actual, m))}
        </td>
      ))}
    </tr>
  );
}
